export default {
  common: {
    login: 'Login',
    logout: 'Logout',
    submit: 'Submit',
    cancel: 'Cancel',
    confirm: 'Confirm',
    save: 'Save',
  },
  login: {
    title: 'Login',
    email: 'Email',
    password: 'Password',
    remember: 'Remember me',
    forgot: 'Forgot password?',
    error: 'Invalid email or password',
    subtitle: 'Automated Quantitative Trading System',
    telegramLogin: 'Login with Telegram',
  },
  nav: {
    dashboard: 'Dashboard',
    trading: 'Trading',
    settings: 'Settings',
    message: 'Message'
  },
  dashboard: {
    title: 'Dashboard',
    totalAssets: 'Total Assets',
    dailyPnL: 'Daily P&L',
    activeStrategies: 'Active Strategies',
    recentTrades: 'Recent Trades',
    running: 'Running',
    paused: 'Paused',
    timeAgo: '{time} minutes ago'
  },
  trading: {
    title: 'Trading Management',
    strategyConfig: 'Strategy Config',
    positions: 'Positions',
    selectPair: 'Select Trading Pair',
    pleaseSelect: 'Please Select',
    strategyType: 'Strategy Type',
    conservative: 'Conservative',
    aggressive: 'Aggressive',
    investAmount: 'Investment Amount',
    enterAmount: 'Enter amount',
    startStrategy: 'Start Strategy',
    closePosition: 'Close',
    gridStrategy: 'Grid Strategy',
    trendStrategy: 'Trend Strategy',
    fillRequired: 'Please fill in all required fields',
    strategyStarted: 'Strategy started successfully',
    closingPosition: 'Closing position...',
    conservativeStrategy: 'Conservative Strategy',
    aggressiveStrategy: 'Aggressive Strategy',
    stopSchedule: 'Schedule Stop',
    investMultiplier: 'Investment Multiplier',
    estimatedAmount: 'Estimated Investment: {min} ~ {max} USDT',
    positionAmount: 'Position Amount',
    profit: 'Profit',
    pair: {
      'BTC/USDT': 'Bitcoin/USDT',
      'ETH/USDT': 'Ethereum/USDT',
      'BNB/USDT': 'Binance Coin/USDT',
      'SOL/USDT': 'Solana/USDT'
    },
  },
  settings: {
    title: 'Settings',
    language: 'Language',
    selectLanguage: 'Select Language',
    apiSettings: 'API Settings',
    apiKey: 'API Key',
    enterApiKey: 'Enter API Key',
    secretKey: 'Secret Key',
    enterSecretKey: 'Enter Secret Key',
    riskControl: 'Risk Control',
    maxTradeAmount: 'Max Trade Amount',
    stopLoss: 'Stop Loss',
    notifications: 'Notifications',
    tradeNotification: 'Trade Notification',
    riskAlert: 'Risk Alert',
    saved: 'Settings saved successfully',
    logoutTitle: 'Logout Confirmation',
    logoutConfirm: 'Are you sure you want to logout?',
    membership: 'Membership',
    trial: 'Trial',
    basic: 'Basic',
    pro: 'Pro',
    premium: 'Premium',
    daysRemaining: '{days} days remaining',
    startTrial: 'Start Trial',
    trialStarted: 'Trial started',
    purchase: 'Purchase',
    tradingPairs: 'Trading Pairs',
    validPeriod: 'Valid Period',
    oneMonth: 'One Month',
    unlimited: 'Unlimited',
    paymentTitle: 'Scan to Pay',
    scanToPay: 'Please scan with USDT-TRC20',
  },
  message: {
    title: 'Message Center',
    notifications: 'Notifications',
    logs: 'Logs',
    success: 'Success',
    warning: 'Warning',
    trade: 'Trade',
    system: 'System',
    strategyStarted: '{pair} strategy started',
    profitTarget: 'Profit target reached {amount}',
    tradingLog: '{pair} {action} @ {price}',
    systemLog: 'System {action}'
  }
} 